class CollectionIntroduction extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('button');
    if (!button || this.toggleHandler) return;
    this.setAttribute('data-collapsed', '');
    button.setAttribute('aria-expanded', 'false');
    button.textContent = button.dataset.more;
    button.hidden = false;
    this.toggleHandler = () => {
      const expanded = this.hasAttribute('data-collapsed');
      this.toggleAttribute('data-collapsed', !expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
    };
    button.addEventListener('click', this.toggleHandler);
  }

  disconnectedCallback() {
    this.querySelector('button')?.removeEventListener('click', this.toggleHandler);
    this.toggleHandler = null;
  }
}

if (!customElements.get('admin-v2-collection-introduction')) {
  customElements.define('admin-v2-collection-introduction', CollectionIntroduction);
}
